module.exports = __webpack_public_path__ + "img/one_store_1.c8665128.png";